import { Directive, HostListener, NgZone, OnDestroy, OnInit } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';

@Directive({
    selector: '[customTooltipHandler]',
    standalone: false
})
export class CustomTooltipHandlerDirective implements OnInit, OnDestroy {
  private hideTimeout: any;

  constructor(private tooltip: MatTooltip, private ngZone: NgZone) {}

  ngOnInit(): void {
    this.ngZone.runOutsideAngular(() => {
      setTimeout(() => {
        const scrollableDiv = document.querySelector('.scroll-main');
        if (scrollableDiv) {
          scrollableDiv.addEventListener('scroll', this.onScroll);
        }
      }, 500);
    });
  }
  
  ngOnDestroy(): void {
    document.removeEventListener('scroll', this.onScroll);
  }

  private onScroll = (): void => {
    this.tooltip.hide();
  };

  @HostListener('click')
  onClick(): void {
    if (this.hideTimeout) {
      clearTimeout(this.hideTimeout);
    }

    this.tooltip.show();

    this.hideTimeout = setTimeout(() => {
      this.tooltip.hide();
    }, 5000);
  }
}